// @ts-nocheck
import { Trans } from '@lingui/react'
import classNames from 'clsx'
import { bool, func, number, shape, string } from 'prop-types'
import { type FunctionComponent } from 'react'

import { InferPropsWithDefaults } from 'shared/utils/propTypes'
import { normalizeUrl } from 'shared/utils/url'
import Image from 'views/components/atoms/Image'
import SearchSuggestionName from 'views/components/organisms/SearchBox/SearchBoxListItem/SearchSuggestionName'
import { SuggestContentES_v3 as SuggestContentES } from 'views/utils/propTypes'
import { isRequired } from 'views/utils/propTypeUtils'

import { SearchHit } from './../types'
import { enhanceWithTrackingData } from './helpers'
import ItemPrice from './ItemPrice'
import ItemStars from './ItemStars'

const PreQueryListItem: FunctionComponent<ComponentProps> = ({
  mobile,
  item,
  highlighted,
  last,
  position,
  selected,
}) => {
  const {
    id,
    hasVariants,
    name,
    prices,
    deeplink,
    thumbnailURL,
    averageRating,
    objectID,
    queryID,
  } = item as SearchHit

  const classList = classNames(
    'a-link a-link--no-underline o-PreQueryListItem l-flex',
    {
      'o-PreQueryListItem--highlighted': highlighted,
      'u-border--bottom@medium': !last,
      'o-PreQueryListItem--focused': selected,
    }
  )

  const productUrl = enhanceWithTrackingData(deeplink, {
    eventName: 'click on product in pre-suggest',
    eventType: 'click',
    objectIDs: `[${objectID}]`,
    position,
    queryID,
  })

  return (
    <li data-product-id={id}>
      <a
        className={classList}
        href={normalizeUrl(productUrl)!}
        data-clientside-hook="SearchBoxListItemLink_PQ"
      >
        <Image
          src={thumbnailURL}
          srcWidth={128}
          srcHeight={128}
          className="o-SearchBox__image u-border-radius u-background-color--background u-margin--right l-flex__fixed"
          alt={name}
        />
        <div className="l-flex l-flex--vertical-stretch l-flex__primary u-color--blue u-font-weight--bold">
          <SearchSuggestionName name={name} concat={mobile} />
          <ItemStars rating={averageRating} />
        </div>
        <span className="u-margin--left l-flex__fixed">
          <div className="o-PreQueryListItemPrice u-no-margin u-text-align--right u-text-align--left@small-tiny u-no-wrap">
            {hasVariants && <Trans id="general.label.price.from" />}
            {hasVariants && ' '}
            <ItemPrice prices={prices} />
          </div>
        </span>
      </a>
    </li>
  )
}

const propTypes = {
  item: shape(isRequired(SuggestContentES)).isRequired,
  position: number.isRequired,
  selected: bool,
  queryStr: string,
  handleItemClick: func,
  highlighted: bool,
  last: bool,
  mobile: bool,
}

const defaultProps = {
  mobile: null,
  queryStr: '',
  selected: false,
  handleItemClick: null,
  highlighted: false,
  last: true,
}

type ComponentProps = InferPropsWithDefaults<
  typeof propTypes,
  typeof defaultProps
>

export default PreQueryListItem
